import axiosInstance from '../../utils/axios';
import { EventBookingRequest, EventBookingResponse } from '../types/eventBooking';

export const eventBookingService = {
  bookEvent: async (bookingData: EventBookingRequest): Promise<EventBookingResponse> => {
    try {
      const response = await axiosInstance.post<EventBookingResponse>(
        '/api/v1/events/attend-event/public',
        bookingData
      );
      return response.data;
    } catch (error: any) {
      // Preserve the original error structure
      throw error;
    }
  }
};
